module.exports = __webpack_public_path__ + "img/fondo-banner-principal.0d8d68e7.svg";